// extracted by mini-css-extract-plugin
module.exports = {"TableActions":"TableActions_TableActions__31h0I","FirstBox":"TableActions_FirstBox__1VGoF"};